import { Link } from 'react-router-dom';
import Navbar from '../navigation/Navbar';
import HireTalent from '../app/HireTalent';
import Tips from '../JobHome/Tips';
import Blogs from '../app/Blogs';
import Categories from '../app/Categories';
import Footer from '../../components/app/Footer';
import JobDesc from '../DailyJobs/JobDesc';
import { Typography } from '@mui/material';
import toList from '../utils/ComponentUtil';
import PostTalentTemplate from './PostTalentTemplate';
import { useEffect, useState } from 'react';
import TalentsAPI from '../Apis/TalentsAPI';


function PostTalentPage() {
    const [talent, setTalent] = useState();
    const [talents, setTalents] = useState();

    useEffect(() => {
        if(talent) {
            let t = TalentsAPI.getTalentsByType(talent);
            setTalents(t);
        }
    }, [talent])
    


    const breadcrumbs = [toList([{ to: "/", child: "Home" }], Link)
        , <Typography className="job-page-name">Post Your Talent</Typography>]

    return (
        <>
        <Navbar selected='Find Work'/>
        <JobDesc talents={talents} talentsTitle={talent + ' Talents'} breadcrumbs={breadcrumbs} startPosting={false} render={() => {
            return <PostTalentTemplate setter={setTalent}/>
        }}></JobDesc>
        <HireTalent/>
        <Tips/>
        <Blogs></Blogs>
        <Categories></Categories>
        <Footer></Footer>
        </>
    );
}

export default PostTalentPage;